(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    // ---------- IOS SCRIPT (YOUR ORIGINAL LOGIC) ----------
    function initIOS() {
      let $slider;

      if (window.innerWidth > 768) {
        $slider = $('.desktop-only .slider');
      } else {
        $slider = $('.mb-only .slider');
      }

      if (!$slider.length || $slider.hasClass('slick-initialized')) return;

      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        dots: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
      });

      const $heading = $('#hero .heading');
      const $paragraph = $('#hero .paragraph');

      function transitionText($el, newText) {
        $el.removeClass('fade-in-up fade-out');
        $el.css('opacity', '0');
        $el.text(newText);
        void $el[0].offsetWidth;
        $el.addClass('fade-in-up');
      }

      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const enteringAmber = nextSlide === 3 && currentSlide !== 3;
        const leavingAmber = nextSlide !== 3 && currentSlide === 3;

        if (enteringAmber) {
          transitionText($heading, 'Amber Rose x LUST');
          transitionText(
            $paragraph,
            'A powerful collaboration with Amber Rose — intimacy boosters crafted to elevate connection and confidence.'
          );
        } else if (leavingAmber) {
          transitionText($heading, 'Get intimate with us');
          transitionText(
            $paragraph,
            'Lust is your go-to for turning up the heat — fast-acting intimacy boosters in shots, gummies & honey.'
          );
        }
      });
    }

    // ---------- ANDROID + DESKTOP SCRIPT ----------
    function initOtherDevices() {
      const $desktopSlider = $('.desktop-only .slider');
      const $mobileSlider = $('.mb-only .slider');

      const isDesktop = window.matchMedia('(min-width:769px)').matches;
      const $slider = isDesktop ? $desktopSlider : $mobileSlider;

      if (!$slider.length) return;

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        dots: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
      });
    }

    // ---------- DEVICE CHECK ----------
    if (isIOS()) {
      initIOS();
    } else {
      initOtherDevices();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-features"] && !Shopify.designMode) return;
  try {
    
  $('.mb-carousel').slick({
    prevArrow:"<img class='a-left control-c prev slick-prev' style='transform: translateX(20px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/vtal-left-icon.svg?v=1726421529'>",
    nextArrow:"<img class='a-right control-c next slick-next' style='transform: translateX(-20px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/vtal-right-icon.svg?v=1726421529'>",
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  $(window).on('load', function () {
    $('.mb-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        "<img class='a-left control-c prev slick-prev' style='transform: translateX(20px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/arrow-left-light.png?v=1746211022'>",
      nextArrow:
        "<img class='a-right control-c next slick-next' style='transform: translateX(-20px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/arrow-right-light.png?v=1746211022'>",
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } },
      ],
    });
    $('.mb-carousel').slick('setPosition');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-list"] && !Shopify.designMode) return;
  try {
    
    $(window).on('load', function() {
  $('.mb-carousel-products').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<img class='a-left control-c prev slick-prev' style='transform: translateX(30px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/arrow-left-light.png?v=1746211022'>",
    nextArrow: "<img class='a-right control-c next slick-next' style='transform: translateX(-30px)' src='https://cdn.shopify.com/s/files/1/0890/5552/7222/files/arrow-right-light.png?v=1746211022'>",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 767,  settings: { slidesToShow: 1 } }
    ]
  });
  $('.mb-carousel').slick('setPosition');
});

document.addEventListener('DOMContentLoaded', () => {

  /* iPhone Single Tap Redirect Fix */
  document.querySelectorAll('#products-list .card-wrapper').forEach(wrapper => {

    const urlMatch = wrapper.getAttribute('onclick')?.match(/'(.*?)'/);
    const url = urlMatch ? urlMatch[1] : null;

    if (!url) return;

    wrapper.addEventListener('touchend', function(e) {
      if (e.target.closest('a, button')) return;
      e.preventDefault();
      window.location.href = url;
    });

  });

  /* Hover Image Effect (Same as before but for ALL cards) */
  document.querySelectorAll('#products-list .card').forEach(card => {

    let currentFadeLayer = null;
    const buttons = card.querySelectorAll('.variants .btn');

    buttons.forEach(btn => {

      btn.addEventListener('mouseenter', () => {
        const newImage = btn.getAttribute('data-image');
        if (!newImage) return;

        if (currentFadeLayer) {
          currentFadeLayer.remove();
          currentFadeLayer = null;
        }

        const fadeLayer = document.createElement('div');
        fadeLayer.className = 'fade-layer';
        fadeLayer.style.backgroundImage = `url('${newImage}')`;
        card.appendChild(fadeLayer);

        void fadeLayer.offsetWidth;
        fadeLayer.style.opacity = '1';

        currentFadeLayer = fadeLayer;
      });

      btn.addEventListener('mouseleave', () => {
        if (currentFadeLayer) {
          currentFadeLayer.style.opacity = '0';
          currentFadeLayer.addEventListener('transitionend', () => {
            if (currentFadeLayer) currentFadeLayer.remove();
            currentFadeLayer = null;
          }, { once: true });
        }
      });

    });

  });

});
document.querySelectorAll('.mb-carousel-products .card-wrapper').forEach(card => {

  let startX = 0;
  let startY = 0;
  let isScrolling = false;

  const url = card.dataset.url;

  card.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isScrolling = false;
  });

  card.addEventListener('touchmove', (e) => {
    const dx = Math.abs(e.touches[0].clientX - startX);
    const dy = Math.abs(e.touches[0].clientY - startY);

    if (dx > 10 || dy > 10) {
      isScrolling = true; // user is scrolling
    }
  });

  card.addEventListener('touchend', (e) => {
    if (isScrolling) return; // prevent redirect when swiping
    if (e.target.closest('a, button')) return;

    window.location.href = url;
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  $('.mb-testimonial-carousel').slick({
    centerMode: true,
    centerPadding: '30px',
    adaptiveHeight: true,
    arrows: false,
    dots: true,
        responsive: [
    {
      breakpoint: 1024,
      settings: {
        centerMode: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ]
  });

  } catch(e) { console.error(e); }
})();
})();
